/* eslint-disable eqeqeq */
import React from 'react';
import { Form, Select, Input } from 'semantic-ui-react';
import { DateTimePicker } from 'react-widgets';

export default class BasicInfoForm extends React.PureComponent {
    render() {
        const {
            jmbg, firstName, lastName, maidenName, gender, dateOfBirth, handleInputChange, handleDateChange, bihId, selectedCitizenships,
            jmbgErr, firstNameErr, lastNameErr, dateOfBirthErr, genderErr
        } = this.props;
        return (
            <Form noValidate>
                <Form.Field
                    required
                    // disabled={jmbg && localStorage.getItem('activeRole') !== 'Administrator'}
                    // type="number"
                    control={Input}
                    label="JMBG"
                    placeholder="JMBG"
                    value={jmbg}
                    name="jmbg"
                    onChange={handleInputChange}
                    error={jmbgErr}
                />
                <Form.Field
                    required
                    control={Input}
                    label="Ime"
                    placeholder="Ime"
                    value={firstName}
                    name="firstName"
                    onChange={handleInputChange}
                    error={firstNameErr}
                />
                <Form.Field
                    required
                    control={Input}
                    label="Prezime"
                    placeholder="Prezime"
                    value={lastName}
                    name="lastName"
                    onChange={handleInputChange}
                    error={lastNameErr}
                />
                <Form.Field
                    required
                    control={DateTimePicker}
                    label="Datum rođenja"
                    format="D. M. YYYY."
                    defaultValue={new Date()}
                    time={false}
                    onChange={handleDateChange}
                    value={dateOfBirth}
                    style={{ borderWidth: '0px' }}
                    error={dateOfBirthErr}
                />
                <Form.Field
                    required
                    control={Select}
                    clearable
                    label="Spol"
                    options={this.props.genders.filter((e) => (e.value !== 3))}
                    placeholder="Spol"
                    onChange={this.props.handleInputChange}
                    name="gender"
                    value={gender}
                    error={genderErr}
                />
                <Form.Field
                    control={Input}
                    label="Djevojačko prezime"
                    placeholder="Djevojačko prezime"
                    value={maidenName}
                    name="maidenName"
                    onChange={this.props.handleInputChange}
                    disabled={gender === null || gender === 1}
                />

                <Form.Field
                    required
                    control={Select}
                    options={this.props.citizenships}
                    placeholder="Državljanstvo"
                    onChange={this.props.handleInputChange}
                    value={this.props.selectedCitizenships}
                    name="selectedCitizenships"
                    label="Državljanstvo"
                    search
                    multiple
                    error={this.props.citizenshipsErr}
                />
                <Form.Field
                    control={Select}
                    label="Nacionalnost"
                    clearable
                    options={this.props.nationalities}
                    value={this.props.nationality}
                    onChange={this.props.handleInputChange}
                    name="nationality"
                    search
                    disabled={!selectedCitizenships.find(el => el == bihId)}
                />
                {/* check if conditions are needed */}
                {(window.location.pathname === '/filtriranje-studenata/informacije-o-studentu'
                    || window.location.pathname === '/unos-studenta'
                    || window.location.pathname === '/spisak-studenata/informacije-o-studentu') &&
                    <Form.Field
                        control={Select}
                        options={this.props.socialStatuses}
                        placeholder="Socijalni status"
                        onChange={this.props.handleInputChange}
                        value={this.props.selectedSocialStatusTypes}
                        name="selectedSocialStatusTypes"
                        label="Socijalni status"
                        search
                        clearable
                        multiple
                    />
                }
            </Form>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentCreateAndEdit/FormParts/BasicInfoForm.js